import { defineStyle, defineStyleConfig } from '@chakra-ui/react'

const brand = defineStyle({
  borderRadius: 0, // remove the border radius
  fontWeight: 'semibold', // change the font weight
  bg: 'rgb(0, 204, 204)',

  color: 'brand.900',
  _hover: {
    bg: '#508C9B',
  },
})

const baseStyle = defineStyle({
  // width: '100%',
})

export const buttonTheme = defineStyleConfig({
  variants: { brand },
  baseStyle: baseStyle,
})
